import { fetchEndpointData } from '@utils/fetchEndpointData';

import type { TrackingLogsResponse } from './endpoints/TrackingLogsEndpoint.types';

export type { TrackingLogsResponse } from './endpoints/TrackingLogsEndpoint.types';

export async function getTrackingLogs(cursor?: string, take?: number): Promise<TrackingLogsResponse> {
  const params = new URLSearchParams();
  if (cursor) params.set('id', cursor);
  if (take != null) params.set('take', take.toString());

  const queryString = params.toString();
  const url = queryString ? `/api/v1/tracking/list?${queryString}` : '/api/v1/tracking/list';
  return fetchEndpointData<TrackingLogsResponse>(url);
}
